import SigliveServiceV1 from 'Service/sigliveServiceV1';

const getStudio = async (queries = '') => {
  const { data } = await SigliveServiceV1({ method: 'GET', url: `/studio/list?${queries}` });

  return data;
};

export default getStudio;
